export enum BackOfficeDocumentType {
Proeispraxi,
Eispraxi,
Stamp,
Contract,
Dividend,
DailyRegister,
Payment,
TrialBankruptcy,
Confiscation,
Invoice,
Receipt,
Expropriation,
}
